import axios from "../utils/axios";

const apiUrl = process.env.REACT_APP_LEGAL_URL;

export interface Precedent {
    precedentId: number;
    name: string;
    caseTypeId: number;
    precedentFolderId: number | null;
    azureFileReference?: string;
    azureFileContentType?: string;
    sortIndex?: number;
    fileSize?: number;
    addedOn?: string;
}

export interface CaseType {
    caseTypeId: number;
    name: string;
}

export interface PrecedentFolder {
    precedentFolderId: number | null;
    caseTypeId?: number;
    name: string;
}

export interface PrecedentsResponse {
    precedents: Precedent[];
    caseTypes: CaseType[];
    folders: PrecedentFolder[];
}

const getPrecedents = (licence) => {

    return axios.get<PrecedentsResponse>(`${apiUrl}/client/getprecedents/${licence}`);
};

const resourceNestService = {
    getPrecedents
};

export default resourceNestService;
